module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.challenge !== null) ? _c('div', {
    attrs: {
      "id": "challenge"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('table', [_c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Challenge")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('router-link', {
    attrs: {
      "to": ("/challenge/" + (_vm.challenge.uid) + "/")
    }
  }, [_vm._v(_vm._s(_vm.challenge.uid))])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Problem")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('router-link', {
    attrs: {
      "to": ("/problem/" + (_vm.challenge.problem.uid) + "/")
    }
  }, [_vm._v(_vm._s(_vm.challenge.problem.uid))])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Submitter")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('router-link', {
    attrs: {
      "to": ("/profile/" + (_vm.challenge.submitter.uid) + "/")
    }
  }, [_vm._v(_vm._s(_vm.challenge.submitter.name))])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Timestamp")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.challenge.timestamp))])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Total Runtime")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.challenge.metadata['runtime']))])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Total Memory")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.challenge.metadata['memory']))])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Result")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.getResult(_vm.challenge.state, _vm.challenge.metadata['result'])))])])]), _vm._v(" "), (_vm.is_admin) ? [_c('button', {
    on: {
      "click": function($event) {
        _vm.onRejudge()
      }
    }
  }, [_vm._v("Rejudge "), _c('span', {
    staticClass: "fa fa-refresh btn"
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.challenge.subtasks), function(subtask) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(subtask.index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(_vm.getResult(subtask.state, subtask.metadata['result'])))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(subtask.metadata['runtime']))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(subtask.metadata['memory']))])])
  })], 2)])]), _vm._v(" "), (_vm.challenge.metadata['verdict'] !== '') ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('pre', [_c('code', {
    staticClass: "nohighlight"
  }, [_vm._v(_vm._s(_vm.challenge.metadata['verdict']))])])])]) : _vm._e(), _vm._v(" "), (_vm.challenge.code !== undefined) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('pre', {
    ref: "code"
  }, [_c('code', [_vm._v(_vm._s(_vm.challenge.code))])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col"
  }, [_vm._v("Test")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Result")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Runtime (ms)")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Memory (KB)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21826304"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Challenge.vue
// module id = 574
// module chunks = 0